import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ListTodo, Mic, Settings, ShieldCheck, Terminal } from 'lucide-react';

/**
 * Sidebar component for desktop navigation
 * Displays vertical navigation on the left side for lg+ screens
 */
const Sidebar = ({ showAdmin = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const getCurrentTab = () => {
    if (location.pathname.startsWith('/record')) return 'record';
    if (location.pathname.startsWith('/inspections')) return 'reports';
    if (location.pathname.startsWith('/settings')) return 'settings';
    if (location.pathname.startsWith('/admin')) return 'admin';
    if (location.pathname.startsWith('/debug')) return 'debug';
    return 'reports';
  };

  const currentTab = getCurrentTab();

  const navItems = [
    { id: 'record', label: t('nav.record'), icon: Mic, path: '/record' },
    { id: 'reports', label: t('nav.reports'), icon: ListTodo, path: '/' },
    { id: 'settings', label: t('nav.settings'), icon: Settings, path: '/settings' },
  ];

  if (showAdmin) {
    navItems.push({ id: 'admin', label: t('nav.admin'), icon: ShieldCheck, path: '/admin' });
    navItems.push({ id: 'debug', label: t('nav.debug'), icon: Terminal, path: '/debug' });
  }

  return (
    <aside className="sidebar">
      <nav className="sidebar-nav">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentTab === item.id;

          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className={`sidebar-item ${isActive ? 'active' : ''}`}
              aria-label={item.label}
              title={item.label}
              aria-current={isActive ? 'page' : undefined}
            >
              <Icon size={22} strokeWidth={isActive ? 2.5 : 2} />
            </button>
          );
        })}
      </nav>
    </aside>
  );
};

export default Sidebar;
